import view from "../../views/inroot.js";
import { router } from "../router/index.routes";

let inroot = {
    render: () => {
        
        return view;
    },
    after_render: async () => {
        let html = /*html*/`<a class="text-white" href="news/news-and-updates-08302024" data-navigo>
            <div class=""><div class="alert rounded-0 d-flex align-items-center p-5 bg-light-success mb-0" role="alert">
            <i class="fas fa-rss-square fs-2qx text-success me-4"><span class="path1"></span><span class="path2"></span></i>
                    
                <div class="d-flex flex-column">
                    <span class="alert-text"><span data-i18n="[html]valve.update30082024"></span>
                </div>
            </div></div></a>`;

        let html2 = /*html*/`<a class="text-white" href="https://whatsapp.com/channel/0029VaDpiuXKwqSQwvWh2v24" target="_blank">
            <div class=""><div class="alert rounded-0 d-flex align-items-center p-5 bg-light-success mb-0" role="alert">
            <i class="fas fa-check-square fs-2qx text-success me-4"><span class="path1"></span><span class="path2"></span></i>

                <div class="d-flex flex-column">
                    <span class="alert-text"><span data-i18n="valve.akros_restore">                    
                </span>
            </div></div></a>`;
        
        $("#kt_wrapper").prepend(html2);
        $("#kt_wrapper").localize();
        //console.log('done');
    },
    root: true, 
    rerender: true,
    
};

export default inroot;